import { render } from "./suggestive-search.vue?vue&type=template&id=1542ddae&scoped=true"
import script from "./suggestive-search.vue?vue&type=script&lang=js"
export * from "./suggestive-search.vue?vue&type=script&lang=js"

import "./suggestive-search.vue?vue&type=style&index=0&id=1542ddae&scoped=true&lang=css"

import exportComponent from "/home/rowen/www/html/catholic-club-fleet-base/themes/default/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1542ddae"]])

export default __exports__